document.addEventListener('DOMContentLoaded', function () {
  const isMobile = window.innerWidth <= 768;
  
  // Bu fonksiyon her çağrıldığında DOM'dan yeni referansları alır
  function getCurrentElements() {
    return {
      productGrid: document.getElementById('product-grid'),
      loadingSpinner: document.querySelector('.loading-spinner')
    };
  }

  let isLoading = false;
  let hasMorePages = true;
  let lastUrl = window.location.href;
  
  // Yüklü sayfaları takip et
  const { currentPage: initialPage } = (() => {
    const urlParams = new URL(window.location.href).searchParams;
    return { currentPage: parseInt(urlParams.get('page')) || 1 };
  })();
  let loadedMinPage = initialPage;
  let loadedMaxPage = initialPage;

  // URL params ve current page'i dinamik olarak al
  function getCurrentPageInfo() {
    const urlParams = new URL(window.location.href).searchParams;
    const currentPage = parseInt(urlParams.get('page')) || 1;
    return { urlParams, currentPage };
  }

  // URL değişikliğini kontrol et ve gerekirse durumları sıfırla
  function checkUrlChange() {
    const currentUrl = window.location.href;
    if (currentUrl !== lastUrl) {
      hasMorePages = true;
      isLoading = false;
      // URL değiştiğinde yüklü sayfa aralığını sıfırla
      const { currentPage } = getCurrentPageInfo();
      loadedMinPage = currentPage;
      loadedMaxPage = currentPage;
      lastUrl = currentUrl;
      return true;
    }
    return false;
  }

  // İlk loading spinner'ı oluştur
  function createLoadingSpinner() {
    const elements = getCurrentElements();
    if (!elements.productGrid) return;
    
    // Eğer zaten varsa yeniden oluşturma
    if (elements.loadingSpinner) return;
    
    const loadingSpinner = document.createElement('div');
    loadingSpinner.className = 'loading-spinner';
    loadingSpinner.style.display = 'none';
    elements.productGrid.parentNode.insertBefore(loadingSpinner, elements.productGrid.nextSibling);
  }

  // Sayfa yüklendiğinde spinner'ı oluştur
  createLoadingSpinner();

  function initializeNewProductCards(container) {
    // Alpine.js için yeni elementleri başlat
    if (window.Alpine && container) {
      container.querySelectorAll('[x-data]').forEach(el => {
        if (!el._x_dataStack) {
          window.Alpine.initTree(el);
        }
      });
    }

    // Swipe fonksiyonalitesi için yeni card'ları başlat
    if (window.initializeSwipeFunctionality && container) {
      window.initializeSwipeFunctionality(container);
    }

    // Product card'ların görünürlüğünü ayarla
    container.querySelectorAll('.card-product, .card').forEach(card => {
      card.style.opacity = '1';
      card.style.visibility = 'visible';
    });
  }

  function loadMoreProducts() {
    if (isLoading || !hasMorePages) return;
    
    // Her seferinde güncel elementleri al
    const elements = getCurrentElements();
    
    if (!elements.productGrid) return;

    // Loading spinner'ı yoksa oluştur
    if (!elements.loadingSpinner) {
      createLoadingSpinner();
    }

    isLoading = true;
    const currentLoadingSpinner = getCurrentElements().loadingSpinner;
    if (currentLoadingSpinner) {
      currentLoadingSpinner.style.display = 'block';
    }

    // Yüklü olan en yüksek sayfadan sonraki sayfayı yükle
    const nextPage = loadedMaxPage + 1;
    const url = new URL(window.location.href);
    url.searchParams.set('page', nextPage);
    url.searchParams.set('section_id', elements.productGrid.dataset.id);

    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductGrid = doc.getElementById('product-grid');
        const newProductItems = newProductGrid?.querySelectorAll('li.grid__item');
        
        if (newProductItems && newProductItems.length > 0) {
          // Güncel productGrid referansını tekrar al
          const currentElements = getCurrentElements();
          if (currentElements.productGrid) {
            // Yeni ürünleri ekle
            newProductItems.forEach(item => {
              currentElements.productGrid.appendChild(item);
            });

            // Yeni eklenen ürün kartları için gerekli fonksiyonları başlat
            initializeNewProductCards(currentElements.productGrid);

            // Yüklü sayfa aralığını güncelle
            loadedMaxPage = nextPage;
            
            // URL'yi güncelle - sayfada yüklü olan en yüksek sayfayı gösterir
            const newUrl = new URL(window.location.href);
            if (loadedMaxPage === 1) {
              newUrl.searchParams.delete('page');
            } else {
              newUrl.searchParams.set('page', loadedMaxPage);
            }
            window.history.replaceState({}, '', newUrl);
            lastUrl = newUrl.toString();
          }
        } else {
          hasMorePages = false;
          // Scroll event'ini silmiyoruz, sadece hasMorePages kontrolü yeterli
        }
      })
      .catch(error => {
        console.error('Error loading more products:', error);
      })
      .finally(() => {
        isLoading = false;
        const finalLoadingSpinner = getCurrentElements().loadingSpinner;
        if (finalLoadingSpinner) {
          finalLoadingSpinner.style.display = 'none';
        }
      });
  }

  function loadPreviousProducts() {
    // Yüklü olan en düşük sayfadan önceki sayfayı kontrol et
    if (loadedMinPage <= 1 || isLoading) return;
    
    const elements = getCurrentElements();
    if (!elements.productGrid) return;
    
    const loadBtn = document.querySelector('[data-load-previous]');
    if (!loadBtn) return;
    
    // Loading state'e geç
    isLoading = true;
    loadBtn.disabled = true;
    
    const prevPage = loadedMinPage - 1;
    const url = new URL(window.location.href);
    url.searchParams.set('page', prevPage);
    url.searchParams.set('section_id', elements.productGrid.dataset.id);
    
    fetch(url)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newProductGrid = doc.getElementById('product-grid');
        const newProductItems = newProductGrid?.querySelectorAll('li.grid__item');
        
        if (newProductItems && newProductItems.length > 0) {
          const currentElements = getCurrentElements();
          if (currentElements.productGrid) {
            // Yeni ürünleri başa ekle
            const fragment = document.createDocumentFragment();
            newProductItems.forEach(item => {
              fragment.appendChild(item);
            });
            currentElements.productGrid.insertBefore(fragment, currentElements.productGrid.firstChild);
            
            // Yeni eklenen ürün kartları için gerekli fonksiyonları başlat
            initializeNewProductCards(currentElements.productGrid);
            
            // Yüklü sayfa aralığını güncelle
            loadedMinPage = prevPage;
            
            // URL'yi güncelle (sayfada yüklü olan en düşük sayfayı gösterir)
            const newUrl = new URL(window.location.href);
            if (prevPage === 1) {
              newUrl.searchParams.delete('page');
            } else {
              newUrl.searchParams.set('page', prevPage);
            }
            window.history.replaceState({}, '', newUrl);
            lastUrl = newUrl.toString(); // lastUrl'yi güncelle
            
            // Buton durumunu güncelle
            if (prevPage === 1) {
              loadBtn.style.display = 'none';
            }
          }
        }
      })
      .catch(error => {
        console.error('Error loading previous products:', error);
      })
      .finally(() => {
        isLoading = false;
        loadBtn.disabled = false;
      });
  }

  function handleScroll() {
    // URL değişikliğini kontrol et
    checkUrlChange();
    
    const scrollPosition = window.innerHeight + window.scrollY;
    const threshold = document.documentElement.scrollHeight - (isMobile ? 1700 : 1500);
    if (scrollPosition > threshold) {
      loadMoreProducts();
    }
  }

  window.addEventListener('scroll', handleScroll);
  
  // Önceki ürünleri yükle butonu
  const loadPrevBtn = document.querySelector('[data-load-previous]');
  if (loadPrevBtn) {
    loadPrevBtn.addEventListener('click', loadPreviousProducts);
  }
});
